"use client";
import {
  SelectItemCheckedContext
} from "../__chunks/QI6TYHPV.js";
import "../__chunks/MWF5B7KS.js";
import "../__chunks/63N3TCQX.js";
import "../__chunks/FFSBKSAM.js";
import "../__chunks/72IB6YNO.js";
import {
  useCheckboxCheck
} from "../__chunks/4U4UFXBE.js";
import "../__chunks/EYKMH5G5.js";
import "../__chunks/45YOMIF3.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/ILRXHV7V.js";
import "../__chunks/K2XTQB3X.js";
import "../__chunks/YXGXYGQX.js";

// src/select/select-item-check.tsx
import { useContext } from "react";
var TagName = "span";
var useSelectItemCheck = createHook(
  function useSelectItemCheck2({ store, checked, ...props }) {
    const context = useContext(SelectItemCheckedContext);
    checked = checked != null ? checked : context;
    props = useCheckboxCheck({ ...props, checked });
    return props;
  }
);
var SelectItemCheck = forwardRef(function SelectItemCheck2(props) {
  const htmlProps = useSelectItemCheck(props);
  return createElement(TagName, htmlProps);
});
export {
  SelectItemCheck,
  useSelectItemCheck
};
